import { render } from "./LoyKrathongOverlay.vue?vue&type=template&id=60f1cf12&scoped=true"
import script from "./LoyKrathongOverlay.vue?vue&type=script&lang=js"
export * from "./LoyKrathongOverlay.vue?vue&type=script&lang=js"

import "./LoyKrathongOverlay.vue?vue&type=style&index=0&id=60f1cf12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f1cf12"]])

export default __exports__